import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { EnrollmentResponse } from '../components/hoc/context/api';

export type Configuration = {
	connector: EnrollmentResponse;
	isMockAllowed: boolean;
};

export default function useMockConfiguration(): Configuration {
	const {
		config: { connector },
	} = useStaticQuery<{ config: Configuration }>(graphql`
		query mockConfigurationQuery {
			config: mockConfiguration {
				connector {
					status
					data {
						service
						state
						card {
							type
							bin
							digitalWalletKey
							group
							memberId
							pcn
						}
					}
				}
			}
		}
	`);

	return {
		isMockAllowed:
			process.env.GATSBY_ALLOW_MOCK === 'true' ||
			process.env.GATSBY_ALLOW_MOCK === '1',
		connector: connector,
	};
}
